import { Link } from 'react-router-dom';

const LAST_UPDATED = '26 de marzo de 2026';

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-slate-50 border-b border-gray-200 py-12">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 text-sm font-semibold mb-6 cursor-pointer">
            <i className="ri-arrow-left-line" />
            Volver al inicio
          </Link>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Política de Privacidad</h1>
          <p className="text-gray-400 text-sm">Última actualización: {LAST_UPDATED}</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-14">
        <div className="flex flex-col gap-10 text-sm text-gray-600 leading-relaxed">

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. Información que recopilamos</h2>
            <p className="mb-3">RemesasVE recopila información mínima necesaria para operar nuestros servicios:</p>
            <ul className="list-disc list-inside flex flex-col gap-2 ml-2">
              <li><strong>Dirección de correo electrónico:</strong> solo si decides suscribirte a nuestras alertas de tasas. Este dato es completamente voluntario.</li>
              <li><strong>Datos de uso anónimos:</strong> a través de herramientas de análisis como Google Analytics, recopilamos datos estadísticos sobre el uso del sitio (páginas visitadas, tiempo en el sitio, país de origen). Estos datos no te identifican personalmente.</li>
              <li><strong>Cookies técnicas:</strong> usamos cookies estrictamente necesarias para el funcionamiento del sitio y para recordar preferencias básicas.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. Cómo usamos tu información</h2>
            <ul className="list-disc list-inside flex flex-col gap-2 ml-2">
              <li>Enviar alertas de tasas de cambio si te suscribiste voluntariamente.</li>
              <li>Mejorar el contenido y la funcionalidad de RemesasVE.</li>
              <li>Analizar el comportamiento de uso para optimizar la experiencia del usuario.</li>
            </ul>
            <p className="mt-3">
              <strong>No vendemos, alquilamos ni compartimos tu correo electrónico</strong> con terceros, salvo que la ley lo exija.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Proveedores externos y enlaces de afiliados</h2>
            <p className="mb-3">
              RemesasVE incluye enlaces a sitios de terceros (Wise, Remitly, Western Union, WorldRemit). Cuando haces clic en estos enlaces y completas una transacción, podemos recibir una comisión. Estos terceros tienen sus propias políticas de privacidad independientes.
            </p>
            <p>
              No somos responsables del contenido, prácticas de privacidad o políticas de esos sitios externos. Te recomendamos revisar sus políticas antes de registrarte.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Retención de datos</h2>
            <p>
              Conservamos tu correo electrónico mientras tu suscripción esté activa. Puedes cancelar tu suscripción en cualquier momento haciendo clic en el enlace "Cancelar suscripción" en cualquiera de nuestros correos.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. Tus derechos</h2>
            <ul className="list-disc list-inside flex flex-col gap-2 ml-2">
              <li><strong>Acceso:</strong> puedes solicitar una copia de los datos que tenemos sobre ti.</li>
              <li><strong>Eliminación:</strong> puedes solicitar que eliminemos tu dirección de correo electrónico de nuestras listas.</li>
              <li><strong>Corrección:</strong> puedes solicitar que corrijamos datos incorrectos.</li>
            </ul>
            <p className="mt-3">Para ejercer estos derechos, escríbenos a <a href="mailto:info@remesasve.com" className="text-green-600 font-semibold">info@remesasve.com</a>.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. Seguridad</h2>
            <p>
              Implementamos medidas técnicas y organizativas razonables para proteger tu información personal. Sin embargo, ningún sistema de transmisión por internet es 100% seguro.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. Cambios a esta política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad ocasionalmente. La fecha de "última actualización" al inicio de esta página refleja la versión más reciente. Si realizamos cambios significativos, te notificaremos por correo si estás suscrito.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">8. Contacto</h2>
            <p>
              Si tienes preguntas sobre esta Política de Privacidad, contáctanos en:{' '}
              <a href="mailto:info@remesasve.com" className="text-green-600 font-semibold">info@remesasve.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
